import { useEffect } from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "src/@/components/ui/select";
import Iconify from 'src/components/Iconify';

const UNIT_OPTIONS = [
    { value: 'minutes', label: 'Minuto(s)' },
    { value: 'hours', label: 'Hora(s)' },
    { value: 'days', label: 'Dia(s)' },
];

const MAX_MINUTES = 43200; // 30 days

const getMaxValue = (unit) => {
    switch (unit) {
        case 'minutes': return MAX_MINUTES;
        case 'hours': return 720; // 30 days
        case 'days': return 30;
        default: return MAX_MINUTES;
    }
};

const CardWait = ({ block, changeBlock }) => {
    const waitValue = block.data?.waitValue || '';
    const waitUnit = block.data?.waitUnit || 'minutes';

    // Persist default unit on mount if not yet saved
    useEffect(() => {
        if (!block.data?.waitUnit) {
            changeBlock({ name: 'waitUnit', value: 'minutes' });
        }
    }, []);

    const handleValueChange = (e) => {
        const val = e.target.value;
        if (val === '' || /^\d+$/.test(val)) {
            const num = parseInt(val) || 0;
            const max = getMaxValue(waitUnit);
            changeBlock({ name: 'waitValue', value: num > max ? max : val });
        }
    };

    const handleUnitChange = (unit) => {
        changeBlock({ name: 'waitUnit', value: unit });
        // Adjust value if it exceeds new max
        const max = getMaxValue(unit);
        const currentVal = parseInt(waitValue) || 0;
        if (currentVal > max) {
            changeBlock({ name: 'waitValue', value: max });
        }
    };

    return (
        <div className="w-full space-y-4">
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                        Duração
                    </label>
                    <input
                        type="number"
                        min="1"
                        max={getMaxValue(waitUnit)}
                        value={waitValue}
                        onChange={handleValueChange}
                        placeholder="Ex: 5"
                        className="w-full rounded-xl border border-gray-200 px-3 py-2 text-sm focus:border-[#7C3AED] focus:ring-[#7C3AED]/20 focus:outline-none focus:ring-2"
                    />
                </div>
                <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5">
                        Unidade
                    </label>
                    <Select value={waitUnit} onValueChange={handleUnitChange}>
                        <SelectTrigger className="w-full">
                            <SelectValue placeholder="Selecione" />
                        </SelectTrigger>
                        <SelectContent>
                            {UNIT_OPTIONS.map((opt) => (
                                <SelectItem key={opt.value} value={opt.value}>
                                    {opt.label}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                </div>
            </div>

            <div className="flex items-start gap-2.5 p-3 rounded-xl bg-amber-50 border border-amber-200">
                <Iconify icon="mdi:information-outline" width={18} className="text-amber-600 mt-0.5 shrink-0" />
                <p className="text-xs text-amber-700">
                    As ações após esta serão executadas após o tempo de espera definido. A automação será pausada e retomada automaticamente.
                </p>
            </div>
        </div>
    );
};

export default CardWait;
